// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vdTO","textarea":"styles_textarea__3XZLM"};